'use strict';

module.exports = function() {
    var $home = $("#home");

    var homeHeight = $home.height();

    $(window).scroll(function(evt) {

        if ($(this).scrollTop() + $(this).height() > homeHeight) {
            $home.addClass('stick');
        } else {
            $home.removeClass('stick');
        }
    });
};



// WEBPACK FOOTER //
// ./resources/js/components/introScroll.js